class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initSwiperIfNeeded();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  initSwiperIfNeeded() {
    if (window.innerWidth >= 1) {
      new Swiper('.mini-cart__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        grabCursor: true,
        freeMode: true,
        mousewheel: true,
        scrollbar: {
          el: '.mini-cart__scrollbar',
          draggable: true,
          hide: false
        }
      });
    }
  }
}

customElements.define('cart-recommendations', CartRecommendations);
